import api from '../../features/components/api';

// Get connection details
export const getAllConnections = async (username) => {
  try {
    const response = await api.get(`/users/all`);
    return response.data;
  } catch (error) {
    throw error.response?.data?.message || 'Failed to get connection details';
  }
};

// Get all users by role
export const getAllUsersByRole = async () => {
  try {
    const response = await api.get(`/users/all`);
    return response.data;
  } catch (error) {
    throw error.response?.data?.message || 'Failed to get users';
  }
};

// Get connections by type and status
export const getConnectionsByTypeAndStatus = async (type, status) => {
  try {
    type = type.toUpperCase();
    status = status.toUpperCase();
    const response = await api.get(`/users/connection?type=${type}&status=${status}`);
    return response.data;
  } catch (error) {
    throw error.response?.data?.message || 'Failed to get connections';
  }
};

// Send connection request
export const sendConnection = async (username) => {
  try {
    const response = await api.post(`/connections/send-connection/${username}`);
    return response.data;
  } catch (error) {
    throw error.response?.data?.message || 'Failed to send connection request';
  }
};

// Accept connection
export const acceptConnection = async (username) => {
  try {
    const response = await api.get(`/connections/accept/${username}`);
    return { username, message: response.data };
  } catch (error) {
    throw error.response?.data?.message || 'Failed to accept connection';
  }
};

// Reject connection
export const rejectConnection = async (username) => {
  try {
    const response = await api.put(`/connections/reject/${username}`);
    return { username, message: response.data };
  } catch (error) {
    throw error.response?.data?.message || 'Failed to reject connection';
  }
};

// Get connection details
export const getConnectionDetails = async (username) => {
  try {
    const response = await api.get(`/connections/connection/${username}`);
    return response.data;
  } catch (error) {
    throw error.response?.data?.message || 'Failed to get connection details';
  }
};
